const descriptions = document.querySelectorAll(
  '.collection-hero__description--collapsible'
);

descriptions.forEach(function (description) {
  const button = description.nextElementSibling;

  if (
    !button ||
    !button.classList.contains('collection-hero__description-toggle')
  ) {
    return;
  }

  const mobileQuery = window.matchMedia('(max-width: 749px)');

  function updateLayout() {
    if (!mobileQuery.matches) {
      // Desktop
      button.hidden = true;
      description.classList.remove('is-expanded');
      button.setAttribute('aria-expanded', 'false');
      button.textContent = 'Weiterlesen';
      return;
    }

    // Mobile: prüfen, ob der eingeklappte Text überhaupt überläuft
    const isOverflowing =
      description.scrollHeight > description.clientHeight + 2;

    button.hidden = !isOverflowing;
  }

  button.addEventListener('click', function () {
    const expanded = description.classList.toggle('is-expanded');

    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    button.textContent = expanded
      ? 'Weniger anzeigen'
      : 'Weiterlesen';
  });

  updateLayout();

  // Nur reagieren, wenn wirklich zwischen Mobile/Desktop gewechselt wird.
  // Nicht beim normalen Scrollen.
  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', updateLayout);
  } else {
    mobileQuery.addListener(updateLayout);
  }
});